export {};
//# sourceMappingURL=School.js.map